import { render, staticRenderFns } from "./uploadRecord.vue?vue&type=template&id=c57e265c&scoped=true"
import script from "./uploadRecord.vue?vue&type=script&lang=js"
export * from "./uploadRecord.vue?vue&type=script&lang=js"
import style0 from "./uploadRecord.vue?vue&type=style&index=0&id=c57e265c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57e265c",
  null
  
)

export default component.exports